import React from 'react';
import Icon from '../../shared/Icon';
import './AlertSteps.css';
import ReportStepOutput from './ReportStepOutput';
import AlertChannelPicker from './AlertChannelPicker';
import { hasAnyRecipient } from '../alertRecipients';

/**
 * Step 3 — Recipients and channel.
 *
 * The Output step is reused rather than cloned, so "Email to self", "Email To
 * Others" and "ADD RECIPIENT" are literally the same component as Reports and
 * cannot drift. Recipients are typed exactly as they are today — nothing is
 * resolved from data, and this step is not a replacement for the Report
 * recipient list.
 *
 * The disclosure is the point of the step. Recipients receive **every** subject
 * the alert matches, so scoping the alert is a deliberate choice rather than
 * something to discover from a 400-row email. The exact wording is owned by
 * PRD-1259; what is here says the true thing and should be replaced verbatim
 * from that ticket when it is picked up.
 */
const AlertStepRecipients = ({ formData, onSetFormData, dryRun }) => {
  const result = dryRun?.result;
  const recipients = formData.reportRecipients ?? [];
  const emailToSelf = formData.reportEmailToSelf !== false;
  const matched = result?.subjectsMatched;

  return (
    <div className="alert-step-content">
      <ReportStepOutput
        formData={formData}
        onSetFormData={onSetFormData}
        title="Recipients and channel"
      />

      {/* AC9 — stated once a recipient exists, which is the moment it matters. */}
      {(recipients.length > 0 || emailToSelf) && (
        <div className="resui-banner resui-banner--info alert-inline-block">
          <Icon name="groups" />
          <span className="resui-banner-text">
            Every recipient receives every subject this alert matches
            {typeof matched === 'number' ? ` — ${matched} on current data` : ''}.
            Scope the alert to the subjects these people should see.
          </span>
        </div>
      )}

      {/* AC8 — matches the dataset validation pattern in the query step. */}
      {!hasAnyRecipient(formData) && (
        <div className="resui-banner resui-banner--alert alert-inline-block">
          <Icon name="warning_amber" />
          <span className="resui-banner-text">
            A recipient is required. Add an email address or send to yourself.
          </span>
        </div>
      )}

      <AlertChannelPicker
        formData={formData}
        onSetFormData={onSetFormData}
        previews={result?.channelPreviews ?? []}
      />
    </div>
  );
};

export default AlertStepRecipients;
